import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { ArrowRight, Loader2, Package, MapPin } from "lucide-react";

export const SearchInput = ({
  initialReference = "",
  initialPlz = "",
  autoFocus = false,
  compact = false,
}) => {
  const [reference, setReference] = useState(initialReference);
  const [plz, setPlz] = useState(initialPlz);
  const [busy, setBusy] = useState(false);
  const navigate = useNavigate();

  const submit = (e) => {
    e?.preventDefault?.();
    const r = reference.trim();
    const p = plz.trim();
    if (!r || !p) return;
    setBusy(true);
    navigate(`/track/${encodeURIComponent(r)}?plz=${encodeURIComponent(p)}`);
    setTimeout(() => setBusy(false), 800);
  };

  if (compact) {
    return (
      <form
        onSubmit={submit}
        className="flex w-full items-stretch overflow-hidden rounded-xl border border-slate-200 bg-white"
        data-testid="tracking-search-form"
      >
        <input
          type="text"
          value={reference}
          onChange={(e) => setReference(e.target.value)}
          placeholder="Sendungsnummer"
          autoFocus={autoFocus}
          className="w-full min-w-0 bg-transparent px-4 py-3 text-sm text-slate-900 placeholder:text-slate-400 focus:outline-none"
          data-testid="tracking-search-input"
        />
        <input
          type="text"
          value={plz}
          onChange={(e) => setPlz(e.target.value)}
          placeholder="PLZ"
          maxLength={10}
          className="w-28 min-w-0 border-l border-slate-200 bg-transparent px-3 py-3 text-sm text-slate-900 placeholder:text-slate-400 focus:outline-none"
          data-testid="tracking-search-plz"
        />
        <button
          type="submit"
          disabled={busy || !reference.trim() || !plz.trim()}
          className="inline-flex shrink-0 items-center gap-2 bg-indigo-600 px-4 py-3 text-xs font-semibold text-white transition-colors hover:bg-indigo-700 disabled:opacity-50"
          data-testid="tracking-search-submit"
        >
          {busy ? (
            <Loader2 className="animate-spin" size={14} />
          ) : (
            <ArrowRight size={14} />
          )}
          Verfolgen
        </button>
      </form>
    );
  }

  return (
    <form
      onSubmit={submit}
      className="w-full space-y-5"
      data-testid="tracking-search-form"
    >
      <div className="grid grid-cols-1 gap-4 md:grid-cols-2">
        <div>
          <label className="mb-2 block text-sm font-medium text-slate-700">
            Sendungsnummer
          </label>
          <div className="relative">
            <Package
              className="pointer-events-none absolute left-4 top-1/2 -translate-y-1/2 text-slate-400"
              size={18}
            />
            <input
              type="text"
              value={reference}
              onChange={(e) => setReference(e.target.value)}
              placeholder="z. B. 12345678"
              autoFocus={autoFocus}
              className="w-full rounded-xl border border-slate-200 bg-slate-50 py-3.5 pl-11 pr-4 text-base text-slate-900 placeholder:text-slate-400 transition-colors focus:border-indigo-500 focus:bg-white focus:outline-none focus:ring-4 focus:ring-indigo-100"
              data-testid="tracking-search-input"
            />
          </div>
        </div>
        <div>
          <label className="mb-2 block text-sm font-medium text-slate-700">
            PLZ Empfänger
          </label>
          <div className="relative">
            <MapPin
              className="pointer-events-none absolute left-4 top-1/2 -translate-y-1/2 text-slate-400"
              size={18}
            />
            <input
              type="text"
              value={plz}
              onChange={(e) => setPlz(e.target.value)}
              placeholder="z. B. 63834"
              maxLength={10}
              className="w-full rounded-xl border border-slate-200 bg-slate-50 py-3.5 pl-11 pr-4 text-base text-slate-900 placeholder:text-slate-400 transition-colors focus:border-indigo-500 focus:bg-white focus:outline-none focus:ring-4 focus:ring-indigo-100"
              data-testid="tracking-search-plz"
            />
          </div>
        </div>
      </div>
      <button
        type="submit"
        disabled={busy || !reference.trim() || !plz.trim()}
        className="inline-flex w-full items-center justify-center gap-3 rounded-xl bg-indigo-600 px-6 py-4 text-base font-semibold text-white shadow-sm shadow-indigo-600/20 transition-all hover:bg-indigo-700 hover:shadow-md hover:shadow-indigo-600/30 disabled:cursor-not-allowed disabled:opacity-50"
        data-testid="tracking-search-submit"
      >
        {busy ? (
          <Loader2 className="animate-spin" size={18} />
        ) : (
          <ArrowRight size={18} />
        )}
        Sendung verfolgen
      </button>
    </form>
  );
};
